import React from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  Card,
  Button,
  useTheme,
} from "@mui/material";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";

const SupportPage = () => {
  const theme = useTheme();
  return (
    <Box sx={{ backgroundColor: "#e6f2ff", py: 5 }}>
      <Box
        sx={{
          textAlign: "center",
        }}
      >
        <Container>
          <Typography variant="h4" sx={{ color: theme.palette.secondary.main}} fontWeight="bold" gutterBottom>
            We're Here to Help
          </Typography>
          <Typography variant="h6">
            Reach out to us anytime, and we'll gladly assist you.
          </Typography>
        </Container>
      </Box>

      {/* Contact Options */}
      <Container sx={{ mt: 5 }}>
        <Grid container spacing={4}>
          <Grid item xs={12} md={4}>
            <Card sx={{ textAlign: "center", p: 3, boxShadow: 3 }}>
              <SupportAgentIcon sx={{ fontSize: 50, color: "#4CAF50", mb: 2 }} />
              <Typography variant="h6" fontWeight="bold" gutterBottom>
                Live Chat Support
              </Typography>
              <Typography variant="body1" sx={{ mb: 3 }}>
                Chat with our support agents for real-time assistance.
              </Typography>
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#4CAF50",
                  "&:hover": { backgroundColor: "#388E3C" },
                }}
              >
                Start Chat
              </Button>
            </Card>
          </Grid>

          <Grid item xs={12} md={4}>
            <Card sx={{ textAlign: "center", p: 3, boxShadow: 3 }}>
              <EmailIcon sx={{ fontSize: 50, color: "#2196F3", mb: 2 }} />
              <Typography variant="h6" fontWeight="bold" gutterBottom>
                Email Support
              </Typography>
              <Typography variant="body1" sx={{ mb: 3 }}>
                Send us your queries, and we’ll get back to you within 24 hours.
              </Typography>
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#2196F3",
                  "&:hover": { backgroundColor: "#1976D2" },
                }}
              >
                Email Us
              </Button>
            </Card>
          </Grid>

          <Grid item xs={12} md={4}>
            <Card sx={{ textAlign: "center", p: 3, boxShadow: 3 }}>
              <PhoneIcon sx={{ fontSize: 50, color: "#FF9800", mb: 2 }} />
              <Typography variant="h6" fontWeight="bold" gutterBottom>
                Call Us
              </Typography>
              <Typography variant="body1" sx={{ mb: 3 }}>
                Speak to our support team for personalized assistance.
              </Typography>
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#FF9800",
                  "&:hover": { backgroundColor: "#F57C00" },
                }}
              >
                Call Now
              </Button>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default SupportPage;
